import { Button } from '@mgrvtechgroup/admin-ds';
import { Check, Copy } from 'lucide-react';
import { useEffect, useState } from 'react';

const COPIED_MS = 1500;

/**
 * 긴 식별자(UUID 등)를 앞 몇 글자만 보여 주고 전체 값은 title·복사 버튼으로 준다.
 * 목록에서 식별자를 통째로 펼치지 않아도 운영자가 값을 옮겨 붙일 수 있게 한다.
 */
export function IdText({
  value,
  label,
  length = 8,
}: {
  value: string;
  label: string;
  length?: number;
}) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => {
      setCopied(false);
    }, COPIED_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [copied]);

  return (
    <span className="inline-flex items-center gap-1">
      <span title={value} className="tabular-nums">
        {value.slice(0, length)}
      </span>
      <Button
        type="button"
        variant="ghost"
        size="xs"
        aria-label={`${label} 복사`}
        onClick={(event) => {
          event.stopPropagation();
          // 클립보드를 쓸 수 없는 환경(비보안 컨텍스트 등)에서는 조용히 넘어간다 — 값은 title로 확인할 수 있다.
          if (!('clipboard' in navigator)) return;
          void navigator.clipboard.writeText(value).then(
            () => {
              setCopied(true);
            },
            () => undefined,
          );
        }}
      >
        {copied ? <Check aria-hidden /> : <Copy aria-hidden />}
      </Button>
      <span role="status" className="sr-only">
        {copied ? `${label}을 복사했습니다` : ''}
      </span>
    </span>
  );
}
